// Replace native sort <select> in collection pages with a brand-styled
// custom dropdown. The native select is kept (visually hidden) so Shopify's
// facet-filters-form.js still receives change events and handles AJAX
// updates exactly as before.

(function () {
  function init(sel) {
    if (sel.dataset.fcSortBound) return;
    sel.dataset.fcSortBound = '1';

    // Build options from native select
    var options = [];
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      options.push({ value: o.value, label: o.text, selected: o.selected });
    }
    var current = options.find(function (o) { return o.selected; }) || options[0];

    // Build custom dropdown
    var d = document.createElement('details');
    d.className = 'fc-sort';
    d.innerHTML =
      '<summary class="fc-sort__btn" aria-haspopup="listbox">' +
        '<span class="fc-sort__label" data-fc-sort-current>' + current.label + '</span>' +
        '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
          '<path d="M2 4l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</summary>' +
      '<ul class="fc-sort__list" role="listbox">' +
        options.map(function (o) {
          return '<li role="option" data-value="' + o.value + '"' +
            (o.selected ? ' data-active aria-selected="true"' : '') +
            '><span>' + o.label + '</span>' +
            (o.selected ? '<span class="fc-sort__tick">✓</span>' : '') +
            '</li>';
        }).join('') +
      '</ul>';

    // Insert after the native select and hide the native one
    sel.style.cssText = 'position:absolute !important;width:1px !important;height:1px !important;padding:0 !important;margin:-1px !important;overflow:hidden !important;clip:rect(0,0,0,0) !important;border:0 !important;';
    // Yank every Shopify-default caret/wrapper that lives next to the select.
    // Walk both the immediate parent (.select wrapper) and one level up.
    var scopes = [sel.parentNode];
    if (sel.parentNode && sel.parentNode.parentNode) scopes.push(sel.parentNode.parentNode);
    var killSel = '.svg-wrapper, svg.icon-caret, .icon-caret, svg.icon, span.svg-wrapper';
    scopes.forEach(function (root) {
      if (!root) return;
      root.querySelectorAll(killSel).forEach(function (el) {
        // Don't kill anything inside our own custom dropdown
        if (el.closest && el.closest('.fc-sort')) return;
        el.parentNode && el.parentNode.removeChild(el);
      });
    });
    sel.parentNode.insertBefore(d, sel.nextSibling);

    // Click handlers
    d.querySelectorAll('li[data-value]').forEach(function (li) {
      li.addEventListener('click', function () {
        var val = li.getAttribute('data-value');
        // Reflect choice
        d.querySelectorAll('li[data-value]').forEach(function (x) {
          x.removeAttribute('data-active');
          x.removeAttribute('aria-selected');
          var t = x.querySelector('.fc-sort__tick');
          if (t) t.remove();
        });
        li.setAttribute('data-active', '');
        li.setAttribute('aria-selected', 'true');
        var tick = document.createElement('span');
        tick.className = 'fc-sort__tick';
        tick.textContent = '✓';
        li.appendChild(tick);

        var label = d.querySelector('[data-fc-sort-current]');
        if (label) label.textContent = li.querySelector('span').textContent;
        d.open = false;

        // Drive the original select + dispatch change so Shopify's
        // facet-filters-form picks it up and AJAX-updates the page.
        sel.value = val;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!d.contains(e.target)) d.open = false;
    });
  }

  function alignProductCount() {
    // Move .product-count next to .facet-filters so both sit on one row.
    var filters = document.querySelector('.facet-filters.sorting, .facet-filters');
    if (!filters) return;
    var count = document.querySelector('.product-count');
    if (!count) return;
    if (count.parentNode === filters) return; // already aligned
    filters.appendChild(count);
    filters.classList.add('fc-filters-row');
  }

  function run() {
    document.querySelectorAll(
      'select#SortBy, select.facet-filters__sort, select[name="sort_by"], select.mobile-facets__sort'
    ).forEach(init);
    alignProductCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
  // Re-run after AJAX collection updates
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.querySelector ? n.querySelector('select#SortBy, select.facet-filters__sort') : false)) {
            run();
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
})();
